import React from "react";
import { Modal } from "../../components/modal";
import { CardPanel, Container } from "./style";
import { goToProject, panelText } from "../../assets/selectProjectUserOrPanel";
import { PROJECT_USER_ROLES } from "../../constants/projectUser";
import { PanelSelectionModalAction } from "../../actions";
import { connect } from "react-redux";

const Index = props => {
  const {
    modalData: { project, projectUsers },
    modalStatus,
    closeModal
  } = props;
  const icon = projectUser => {
    if (projectUser.user_type === PROJECT_USER_ROLES.CUSTODIAN) {
      return "mapsa-pettycasher";
    } else {
      return "mapsa-manager";
    }
  };

  if (modalStatus) {
    return (
      <Modal
        header={{ title: `انتخاب پنل شرکت ${project.name}` }}
        show={modalStatus}
        closeHandler={closeModal}
        height={"70vh"}
        body={
          <Container>
            <div className="hint">
              می‌خواهید به کدام یک از پنل‌های شرکت {project.name} وارد شوید؟
            </div>
            {projectUsers &&
              projectUsers.map(projectUser => {
                return (
                  <CardPanel
                    key={projectUser.id}
                    onClick={() => {
                      goToProject(projectUser, project);
                      closeModal();
                    }}
                  >
                    <div className="top-row">
                      <i className={`role-icon icon ${icon(projectUser)}`} />
                      <div className="panel-name">
                        {panelText(projectUser, " -")}
                      </div>
                    </div>
                    <div className="bottom-row">
                      <div className="text">ورود به پنل</div>
                      <i className="arrow-icon icon mapsa-left-arrow-chevron" />
                    </div>
                  </CardPanel>
                );
              })}
          </Container>
        }
        loading={false}
      />
    );
  } else {
    return null;
  }
};

const mapStateToProps = store => {
  return {
    modalData: store.PanelSelection.modalData,
    modalStatus: store.PanelSelection.modalStatus
  };
};
const mapDispatchToProps = dispatch => {
  return {
    closeModal: () => {
      dispatch(PanelSelectionModalAction.closeModal());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Index);
